import React, { useEffect, useState } from 'react';
import { stripeApi } from '../../firebase/functionsService';
import { connectPanelView } from './connectPanelView';
import { useStripeOnboarding } from '../../hooks/useStripeOnboarding';

// Mørke nok toner til at 11px-teksten på lys bakgrunn når WCAG AA-kontrast.
const TONE_COLOR = { neutral: '#555', warning: '#a84300', success: '#1e7e46', danger: '#a93226' };

export default function StripeConnectPanel({ embedded = false }) {
  const [state,       setState]       = useState(null);
  const [statusError, setStatusError] = useState('');
  const { busy, error, startOnboarding, openDashboard, reset } = useStripeOnboarding();

  useEffect(() => {
    let cancelled = false;

    function loadStatus() {
      stripeApi.getConnectStatus()
        .then(result => { if (!cancelled) setState(result.state); })
        .catch(() => { if (!cancelled) setStatusError('Kunne ikke hente Stripe-status. Last inn siden på nytt, eller kontakt support.'); });
    }

    // Tilbakeknappen fra Stripe kan gjenopprette siden fra bfcache med knappen låst
    // og gammel status — lås opp og hent status på nytt.
    function handlePageShow(event) {
      if (!event.persisted) return;
      reset();
      loadStatus();
    }

    loadStatus();
    window.addEventListener('pageshow', handlePageShow);
    return () => {
      cancelled = true;
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, [reset]);

  function handleClick(action) {
    if (action === 'dashboard') openDashboard();
    else startOnboarding();
  }

  const shownError = statusError || error;

  const view = state ? connectPanelView(state) : null;

  return (
    <div style={embedded ? { ...styles.card, ...styles.embedded } : styles.card}>
      <div style={styles.header}>
        <h2 style={styles.sectionTitle}>Stripe-konto og utbetaling</h2>
        {view && (
          <span style={{ ...styles.badge, color: TONE_COLOR[view.tone], background: TONE_COLOR[view.tone] + '20' }}>
            {view.badge}
          </span>
        )}
      </div>

      {!view && !statusError && <p role="status" style={styles.muted}>Henter status…</p>}
      {view && <p style={styles.text}>{view.description}</p>}
      {shownError && <p role="alert" style={styles.error}>{shownError}</p>}

      {view && view.action && (
        <button style={styles.stripeBtn} onClick={() => handleClick(view.action)} disabled={busy}>
          {busy ? 'Åpner Stripe…' : view.buttonLabel}
        </button>
      )}
    </div>
  );
}

const styles = {
  embedded:     { boxShadow: 'none', padding: '12px 4px 4px', marginBottom: 0, background: 'transparent' },
  card:         { background: '#fff', borderRadius: 12, padding: '24px', marginBottom: 16, boxShadow: '0 1px 8px rgba(0,0,0,0.07)' },
  header:       { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, marginBottom: 12 },
  sectionTitle: { fontSize: 16, fontWeight: 700, color: '#1a1a2e', margin: 0 },
  badge:        { fontSize: 11, fontWeight: 700, borderRadius: 4, padding: '2px 8px', whiteSpace: 'nowrap' },
  text:         { fontSize: 14, color: '#555', margin: '0 0 16px' },
  muted:        { fontSize: 14, color: '#999', margin: '0 0 16px' },
  stripeBtn:    { padding: '10px 20px', borderRadius: 8, border: 'none', background: '#635bff', color: '#fff', fontWeight: 600, fontSize: 14, cursor: 'pointer' },
  error:        { color: '#c0392b', fontSize: 13, background: '#ffeaea', padding: '8px 12px', borderRadius: 6, marginBottom: 12 },
};
